module.exports = __webpack_public_path__ + "static/img/bgi-new.42cb4e3f.png";